import { OnInit, Input, Inject, Component } from '@angular/core';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { SubProject } from 'src/app/model/project/sub-project';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { RequestService } from 'src/app/services/request.service';
import { SnackService } from 'src/app/services/snack.service';
import { Project } from 'src/app/model/project/project';
import { GeneralHelper } from 'src/app/helpers/general-helper';

@Component({
  selector: 'placer-notes-dialog',
  templateUrl: './placer-notes-dialog.component.html',
  styleUrls: ['./placer-notes-dialog.component.scss'],
})
export class PlacerNotesDialogComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  init: boolean = false;
  sending: boolean = false;

  @Input()
  subProjectId: number;

  @Input()
  projectId: number;

  project: Project;
  subProject: SubProject;

  constructor(
    public dialogRef: MatDialogRef<PlacerNotesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private requestService: RequestService,
    private snackService: SnackService
  ) {
    super();
    this.subProjectId = data.subProjectId;
    this.projectId = data.projectId;
  }

  ngOnInit() {
    this.addSubscription(
      this.requestService.getNormal('/projects/' + this.projectId),
      (res) => {
        this.project = res;
        this.subProject = res.subProjects.find(
          (sp: SubProject) => sp.id === this.subProjectId
        );
        this.init = true;
      }
    );
  }

  closeDialog() {
    this.dialogRef.close(null);
  }

  save() {
    this.sending = true;
    this.addSubscription(
      this.requestService.put(this.project, '/projects'),
      (res) => {
        this.dialogRef.close(res);
      },
      (err) => {
        this.sending = false;
        this.snackService.showError(err);
      }
    );
  }

  productInstallerInfoChanged(value: string, index: number) {
    this.project.products[index].productPlacement.installerInfo = value;
  }

  withPlacementNotesChanged(value: string) {
    this.subProject.withPlacementNotes = value;
  }

  trackById(index: number, obj: any) {
    return GeneralHelper.trackById(index, obj);
  }
}
